var _defs, _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1Aroha1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2,.cls-5,.cls-6{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#000;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-4,.cls-5,.cls-6{stroke-linecap:round;}.cls-6{stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.78,
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.46,354.46a8.63,8.63,0,0,0,.53,3.35,4,4,0,0,0,2.33,2.36c2.08.69,4.25-.95,5.36-2.84s1.6-4.11,2.9-5.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.14,329.67a18,18,0,0,0-3.69,4.11,6.17,6.17,0,0,0-.65,5.32,3.78,3.78,0,0,0,4.49,2.28"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 179.29,
    cy: 335.11,
    r: 19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.89,326a30,30,0,0,0,29.44-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.36,327.37a24.94,24.94,0,0,0,16.69,19.93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.07,346.42c-2.64,2.6-4.09,4.11-6.44,6.83"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.32,
    cy: 335.61,
    rx: 2.29,
    ry: 1.72,
    transform: "translate(-187.72 218.03) rotate(-45)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.82,
    cy: 344.11,
    rx: 2.29,
    ry: 1.72,
    transform: "translate(-191.24 226.53) rotate(-45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.66,341.46a26.2,26.2,0,0,1,3.65,6l.31,1.36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.77,403.87,158.56,426a9.56,9.56,0,0,1-.12,4.39c-.56,1.62-1.94,2.81-2.89,4.24s-1.4,3.55-.17,4.75,3.55.6,5-.52c3.19-2.48,4.74-6.61,5.06-10.64s-.44-8.06-1-12.06-1-7.36-.15-11.31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.57,404.55a65.53,65.53,0,0,0,11.19,28.13c-.7,1.55-1.34,2.48-1.31,4.17a4,4,0,0,0,2.68,3.9c2.08.51,4-1.39,4.83-3.37,1.5-3.67.74-7.93-.88-11.55S184,419,182,415.59s-3.62-7.76-3.37-11.72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.85,401.79a81.15,81.15,0,0,0,24.43,2.69c7.85-.34,16.23-2.12,21.6-7.86-6.07-3.79-9.21-10.86-11.21-17.73s-3.24-14.12-7-20.22a9.72,9.72,0,0,0-3.64-3.8c-1.93-1-4.41-.9-6-2.39a14.68,14.68,0,0,1-2-3.18c-.67-1.07-1.81-2.05-3.05-1.81a4.18,4.18,0,0,1-1.84,2.79c-2.27,3.43-3.41,7.47-4.42,11.45A267.47,267.47,0,0,0,145.85,401.79Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.31,351.82a44.9,44.9,0,0,1-19.87-31.32,20.48,20.48,0,0,0,1.8-4.44c.1-.49.55-2.46-.64-2.61s-1.3,1.1-1.56,1.52a5.84,5.84,0,0,0-.67-3.08c-1.3-2-4.54-1.82-6.32-.21a6.36,6.36,0,0,0-1.35,7.46c.64,1.23,1.68,2.2,2.42,3.37,1.19,1.89,1.56,4.16,2.07,6.33a45.21,45.21,0,0,0,23.07,29.44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.39,351.49a5.8,5.8,0,0,1-2.89,8.15,4.73,4.73,0,0,1,.2-2.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1Aroha1);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Aroha_1.142e92d2434919a8c9318b33113a745a.svg";
export { ForwardRef as ReactComponent };